<style lang='less' scoped>
@import '../../../style/common/variable';
.details{position: relative;width: 810px; justify-content: center;overflow: hidden;}
.first{margin-bottom: 50px;}
img {vertical-align: middle;}
.title { margin-top: 32px;font-size: 24px;text-align: center;}
.subbox {display: flex;justify-content: center;align-items: center;justify-content: space-around;height: 24px;margin: 16px 0px;}
// .time {margin-right: 100px;}
// .copyfrom{margin-right: 100px;}
.second{position: relative;}
.keywords{font-weight: 600;}
.keywordsItem{margin: 0px 10px;}
.keywordsItem:hover{color: #13569e;cursor: pointer;}
ul{position: absolute;top: -16px;left: 30px;list-style: none;display: flex;color: rgb(145, 142, 142)}
.preArticle{font-weight: 600;}
.nextArticle{font-weight: 600;}
.otherTitle{cursor: pointer;}
.otherTitle:hover{color: #13569e;}
.content {color: #2c3e50 !important;}
.content a {color: #2c3e50 !important;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .details {width: 94vw;margin-left: 3vw;}
  .subbox{flex-direction: column;height: .7rem;}
  .content{margin: auto .05rem;}
  .second{margin-bottom: -.38rem;
    ul{position: relative; flex-wrap: wrap;top: -.38rem;width: 70vw;}
  }
}
</style>

<!-- 安进 2021.6.11 正文详情组件 2021.06.23数据库接入数据-->
<template>
  <div class="details">
    <div class="first">
      <h1 class="title">{{ curArticle.title }}</h1>
      <div class="subbox">
        <span class="time" v-if="curArticle.id">发布时间：{{ curArticle.time * 1000 | formatDate() }} </span>
        <span class="copyfrom" v-if="curArticle.id">来源：{{ curArticle.copyfrom }}</span>
        <span class="copyfrom" v-if="curArticle.id">作者：{{ curArticle.author }}</span>
        <span class="hits" v-if="curArticle.id">浏览数：{{ curArticle.hits }}</span>
      </div>
      <div class="content" v-html="curArticleContent"></div>
    </div>
    <div class="second" v-if="this.$route.path === '/ZlkDetails' | '/DhxwDetails'">
      <span class="keywords">关键词：</span>
      <ul>
        <li v-for="(item,index) in curArticle.keyword" :key="index">
         <span class="keywordsItem" @click="goKeywords(item)"> {{ item }} </span> |
         </li>
      </ul>
    </div>
    <p><span class="preArticle">上一篇：</span>
      <span @click="previous" class="otherTitle" v-if = "!nopre">{{ preArticle.title}}</span>
      <span class="otherTitle" v-if = "nopre">暂无上一篇</span>
    </p>
    <p><span class="nextArticle">下一篇：</span>
      <span @click="next" class="otherTitle" v-if = "!nonext">{{ nextArticle.title}}</span>
      <span class="otherTitle" v-if = "nonext">暂无下一篇</span>
    </p>
  </div>
</template>

<script>
import arrayFun from '../method/array.js'
import filters from '../method/filter.js'
export default {
  name: '',
  mixins: [filters],
  data()
  {
    return {
      articledata: [], // 所有文章的相关信息
      curID: null, // 当前展示文章的id
      catID: null, //详情文章的catID
      curArticle: {}, // 当前展示文章的相关信息
      curArticleContent: null, // 当前展示文章的正文内容
      preArticle: {}, // 上一篇文章相关信息
      nextArticle: {}, // 下一篇文章相关信息
      curIndex: null, // 当前文章的索引值
      nopre: false, //没有上一篇
      nonext: false //没有下一篇
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.curID = +nval.query.id
        this.getDetails()
      },
      immediate: true
    }
  },
  methods: {
    // 安全解码文章正文（兼容未编码或含非法 % 序列的内容）
    decodeArticleContent(content)
    {
      if (!content) return content
      try
      {
        return decodeURIComponent(content)
      }
      catch (e)
      {
        try
        {
          return decodeURIComponent(content.replace(/%(?![\dA-Fa-f]{2})/g, '%25'))
        }
        catch (e2)
        {
          return content
        }
      }
    },
    // 从数据库获取所有文章数据
    getDetails()
    {
      // 从矿业资讯的数据表中获取所有文章的相关信息
      if (this.$route.path === '/KyzxDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, author: item.author, hits: item.hits, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从资料库的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/ZlkDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, author: item.author, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会新闻的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/DhxwDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, author: item.author, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会新闻的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/LtgkDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid, author: item.author})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会资讯的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/HyxqDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, author: item.author, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
    },
    // 当前展示文章
    show()
    {
      // 当前展示文章的相关信息
      this.articledata.forEach(item =>
      {
        if (Number(item.id) === this.curID) //当前ID数据存在
        
          this.curArticle = item
      })
      // 从矿业资讯的数据表中获取当前展示文章的正文内容
      if (this.$route.path === '/KyzxDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 2, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = this.decodeArticleContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 1, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从资料库的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/ZlkDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 25, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = this.decodeArticleContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 24, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从大会新闻的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/DhxwDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 6, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = this.decodeArticleContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 5, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      else if (this.$route.path === '/LtgkDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 6, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = this.decodeArticleContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 5, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从大会资讯的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/HyxqDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 51, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = this.decodeArticleContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 50, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      this.curIndex = this.articledata.indexOf(this.curArticle)
      if (this.curIndex > 0)
      {
        this.preArticle = this.articledata[this.curIndex - 1]
        this.nextArticle = this.articledata[this.curIndex + 1]
        this.nopre = false
      }
      else
      {
        this.nopre = true
        this.nextArticle = this.articledata[this.curIndex + 1]
      }
    },
    // 点击上一篇文章的标题
    previous()
    {
      if (this.curIndex > 0)
      {
        this.curIndex -= 1
        if (this.$route.path === '/KyzxDetails')
        {
          let url = this.$router.resolve({path: '/KyzxDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/ZlkDetails')
        {
          let url = this.$router.resolve({path: '/ZlkDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/DhxwDetails')
        {
          let url = this.$router.resolve({path: '/DhxwDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/HyxqDetails')
        {
          let url = this.$router.resolve({path: '/HyxqDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        this.nonext = false
      }
      else
        this.nopre = true
    },
    // 点击下一篇文的标题
    next()
    {
      if (this.curIndex < this.articledata.length)
      {
        this.curIndex += 1
        if (this.$route.path === '/KyzxDetails')
        {
          let url = this.$router.resolve({path: '/KyzxDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/ZlkDetails')
        {
          let url = this.$router.resolve({path: '/ZlkDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/DhxwDetails')
        {
          let url = this.$router.resolve({path: '/DhxwDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        else if (this.$route.path === '/HyxqDetails')
        {
          let url = this.$router.resolve({path: '/HyxqDetails', query: {id: this.articledata[this.curIndex].id}})
          window.open(url.href, '_blank')
        }
        this.nopre = false
      }
      else
      {
        // 从矿业资讯的数据表中获取所有文章的相关信息
        if (this.$route.path === '/KyzxDetails')
        {
          let paras1 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
          window.post.getPost(paras1).then((ret) =>
          {
            ret.sort(arrayFun.compareBtoS('time'))
            ret[0].data.forEach(item =>
            {
              this.articledata.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, catid: item.catid})
            })
          })
        }
        // 从资料库的数据表中获取所有文章的相关信息
        else if (this.$route.path === '/ZlkDetails')
        {
          let paras1 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
          window.post.getPost(paras1).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              let keyArr = item.keyword.split(',')
              this.articledata.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
            })
            this.articledata.sort(arrayFun.compareBtoS('time'))
          })
        }
        // 从大会新闻的数据表中获取所有文章的相关信息
        else if (this.$route.path === '/DhxwDetails')
        {
          let paras1 = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
          window.post.getPost(paras1).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              let keyArr = item.keyword.split(',')
              this.articledata.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
            })
            this.articledata.sort(arrayFun.compareBtoS('time'))
          })
        }
        // 从大会资讯的数据表中获取所有文章的相关信息
        else if (this.$route.path === '/HyxqDetails')
        {
          let paras1 = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
          window.post.getPost(paras1).then((ret) =>
          {
            ret[0].data.forEach(item =>
            {
              this.articledata.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, catid: item.catid})
            })
            this.articledata.sort(arrayFun.compareBtoS('time'))
          })
        }
      }
    },
    // 跳转到资料库关键词搜索页面，并将被点击的对象的搜索关键词提交到vuex
    goKeywords(item)
    {
      let obj = {keyword: item, catid: '', sort: '', ssgj: ''}
      let url = this.$router.resolve({path: '/ZlkKeywords', query: obj})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Details.vue